module.exports = __webpack_public_path__ + "img/ground.ebe6cb6d.png";